<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-table-partida"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import ListadoAgGridMixin from '../mixins/listado-ag-grid-mixin';
import { cellRendererNumeroRegistro } from '../utils';

export default {
  name: 'ListadoPartida',
  mixins: [ListadoAgGridMixin],
  data() {
    return {
      columnDefs: [
        {
          headerName: 'NRO. REG.',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'ID',
          field: 'id',
          filter: true,
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'CODIGO',
          field: 'codigo',
          filter: true,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'NOMBRE',
          field: 'nombre',
          filter: true,
          minWidth: 300,
        },
        {
          headerName: 'TIPO PARTIDA',
          field: 'tipo_partida',
          filter: true,
          minWidth: 200,
        },
        {
          headerName: 'ACEPTA REGISTRO',
          cellRenderer: function (params) {
            const aceptaRegistro = params.data.acepta_registro;

            return /*html */ `<span style="color: ${aceptaRegistro ? 'green' : 'red'};">${
              aceptaRegistro ? 'SI' : 'NO'
            }</span>`;
          },
          valueGetter: function (params) {
            return params.data.acepta_registro ? 'SI' : 'NO';
          },
          filter: true,
          minWidth: 130,
          maxWidth: 130,
        },
        {
          headerName: 'CUENTA PADRE',
          cellRenderer: function (params) {
            if (!params.data.padre) {
              return '';
            }

            return /*html*/ `<small>${params.data.padre?.codigo} ${params.data.padre?.nombre}</small>`;
          },
          filter: false,
          minWidth: 300,
          maxWidth: 300,
        },
        {
          headerName: 'TIPO CUENTA (ORACLE)',
          field: 'tipo_oracle',
          filter: false,
          minWidth: 300,
          maxWidth: 300,
        },
        {
          headerName: 'ORACLE ID',
          field: 'oracle_id',
          filter: true,
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'DESCRIPCION',
          field: 'descripcion',
          filter: false,
          minWidth: 300,
          maxWidth: 300,
        },
        {
          headerName: 'GRUPO',
          cellRenderer: function (params) {
            if (!params.data.grupo) {
              return '';
            }

            return /*html*/ `<small>${params.data.grupo?.codigo} ${params.data.grupo?.nombre}</small>`;
          },
          filter: false,
          minWidth: 300,
          maxWidth: 300,
        },
        {
          headerName: 'CUENTA CONTABLE',
          cellRenderer: function (params) {
            if (!params.data.cuenta_contable) {
              if (['Contable Recursos', 'Contable Gastos'].includes(params.data.tipo_partida)) {
                return 'NO APLICA';
              }

              return '';
            }
            return `${params.data.cuenta_contable?.codigo} ${params.data.cuenta_contable?.nombre}`;
          },
          filter: false,
          minWidth: 300,
          maxWidth: 300,
        },
      ],
    };
  },
};
</script>
  
<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-table-partida {
  height: calc(var(--vh, 1vh) * 100 - 19rem);
}
</style>
  